// ─── POP-UP DE PROMOCIÓN ──────────────────────────────────────
// Muestra el modal de promo (si lo renderizó el servidor) tras una breve
// pausa, EN CADA CARGA de la página. La ✕ / Escape / clic en el fondo lo
// cierran para esa vista; al recargar vuelve a aparecer (máxima visibilidad).
(() => {
  "use strict";

  const modal = document.getElementById("promoModal");
  if (!modal) return;

  let lastFocus = null;

  const open = () => {
    lastFocus = document.activeElement;
    modal.hidden = false;
    // Fuerza un frame para que la transición de opacidad/escala se vea.
    requestAnimationFrame(() => modal.classList.add("is-open"));
    document.body.classList.add("promo-open");
    const closeBtn = modal.querySelector(".promo-modal__close");
    if (closeBtn) closeBtn.focus();
  };

  const dismiss = () => {
    modal.classList.remove("is-open");
    document.body.classList.remove("promo-open");
    // Espera a que termine la transición antes de ocultar del todo.
    setTimeout(() => {
      modal.hidden = true;
    }, 300);
    if (lastFocus && typeof lastFocus.focus === "function") lastFocus.focus();
  };

  modal.querySelectorAll("[data-promo-close]").forEach((el) => {
    el.addEventListener("click", dismiss);
  });

  document.addEventListener("keydown", (event) => {
    if (event.key === "Escape" && !modal.hidden) dismiss();
  });

  // Aparece con una pausa para que no compita con la carga del hero.
  setTimeout(open, 900);
})();
